import api from '../../../../services/api';

export default async function apiGetMinimumValues(coupleId) {
  return api.get('/api/v1/payment/minimum_values', {
    params: { couple_id: coupleId },
  });
}
